<template>
  <div class="universal">
    <!--面包屑-->
    <div class="crumbs">
      <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
      <span>教学管理</span>
    </div>
    <!--搜索框-->
    <div class="search">
      <div class="hospital-select">
        <ul class="district-type">
          <em class="label">上架状态 :</em>
          <li>
            <el-select v-model="shelfStates" clearable placeholder="全部" class="image-input" >
              <el-option
                v-for="item in shelf"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </li>
          <em class="label">课程状态 :</em>
          <li>
            <el-select v-model="cStates" clearable placeholder="全部" class="image-input" >
              <el-option
                v-for="item in cState"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li>
            <el-input
              style="width:260px"
              placeholder="请输入课程名称"
              v-model="theSubject"
              @keyup.enter="getCourse('1')"
              clearable>
            </el-input>
          </li>
          <!-- 点击查询 -->
          <div class="search-box">
            <a href="javascript:;" class="search-btn s-btn" @click="getCourse('1')">查询</a>
          </div>
          <!-- 点击新建课程 -->
          <div class="addBtn" @click="_addBtn">新建课程</div>
        </ul>
      </div>
      <!--表格-->
      <div class="batch-process">
        <div class="process-text">批量处理：</div>
          <ul class="process-ul">
            <li @click="upShelf">
              <i class="iconfont icon-shangjia el-button--text"></i>
              <el-button >上架</el-button>
            </li>
            <li @click="downShelf">
              <i class="iconfont icon-xiajia el-button--text"></i>
              <el-button >下架</el-button>
            </li>
          </ul>
      </div>
    </div>

    <p-table :isCamera="true" :withCameraData="withCameraData"  :showCheck="showCheck" ref="listSelection" :head="head" :data="dataList" :operation="operation" @_operation="_operation_" :dynamicOperationName="'teacher'" :autoheight="autoheight" :operationWidth="'160'" @selection="submitSelection"  v-loading="loading" :resSelection="true" :cellClassName="cellClassName" :studyList="studyList" ></p-table>
     <page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage"
            @page-size="__pageSize"></page>

    <right-pops v-if="popShow">
      <router-view/>
    </right-pops>
    <QRcodePage v-if="isShowQR" :QRTitle="QRTitle" :QRId="QRId" :QRType="QRType"  @closeQR="closeQR"></QRcodePage>
  </div>

</template>

<script type="text/ecmascript-6">
  import pTable from '@/components/common/tables/publicTable'
  import zTable from '@/components/common/tables/selectTable'
  import tTable from '@/components/common/tables/teachManageTable'
  import page from '@/components/common/page/page'
  import record from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import medicalNew from '@/components/common/medicalNews/medicalNews/'
  import rightPops from '@/components/common/right/rightPops'
  import router from '../../../../router'
  import http from '@/api/http'
  import * as _ from '@/common/js/config'
  import {cookies} from '@/api/util'
  import {message} from '@/common/js/messages'
  import {nomalTime} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import {onShelfState,changeSex,changeteachType,changeGender,changeAge,changecourseType,courseStates} from '@/common/js/change'

  import QRcodePage from '@/components/common/base/QRcodePage'
  export default {
    components: {
      pTable,
      zTable,
      tTable,
      page,
      record,
      medicalNew,
      rightPops,
      QRcodePage
    },
    data() {
      return {
        popShow: false,
        loading: false,
        autoheight:this.getH(),
        theSubject:'',
        goon:false,
        cellName:'',
        isUpShelf:false,
        showCheck: true,//显示勾选
        conTime:'', //服务器时间
        cState:[{
          value: '',
          label: '全部'
        },{
          value: '2',
          label: '未开始'
        },{
          value: '3',
          label: '进行中'
        },{
          value: '4',
          label: '已结束'
        }],
        shelf: [{
          value: '',
          label: '全部'
        },{
          value: '1',
          label: '未上架'
        },{
          value: '2',
          label: '已上架'
        }],
        cStates: '',
        shelfStates: '',
        //********table  固定项
        withCameraData:{
          props: 'subject',
            label: '课程名称',
            width: '19%'
        },
        head: [
          // {
          //   props: 'subject',
          //   label: '课程名称',
          //   width: '19%'
          // },
          {
            props: 'teacherName',
            label: '授课人',
            width: '7%'
          },{
            props: 'courseTimeStr',
            label: '课程时间',
            width: '15%'
          },
          {
            props: 'teachType',
            label: '教学方式',
            width: '8%'
          },
          {
            props: 'keywords',
            label: '关键词',
            width: '16%'
          },
          {
            props: 'courseTypeId',
            label: '课程分类',
            width: '8%'
          },
          {
            props: 'onShelf',
            label: '上架状态',
            width: '8%'
          },
          {
            props: 'courseState',
            label: '课程状态',
            width: '8%'
          }
        ],
        dataList: [],
        studyList:[],
        operation: [
          {
            operation: '',
            class: 'icon-chakan',
            class2: 'icon-chakan hui',
            title: '查看'
          },
          {
            operation: '',
            class: 'icon-bianji',
            class2: 'icon-bianji hui',
            title: '修改'
          },
          {
            operation: '',
            class: 'icon-jinru',
            class2: 'icon-jinru hui',
            title: '进入'
          },
          {
            operation: '',
            class: 'icon-shanchu',
            class2: 'icon-shanchu hui',
            title: '删除'
          },
          {
            operation: '',
            class: 'icon-EQcode2',
            class2: 'icon-EQcode2 hui',
            title: '二维码'
          },
        ],
        page: {
          currentPage: 1,
          pageSize: 30,
          total: 0,
          allPage: 0
        },
        isShowQR:false,
        QRId:"",
        QRType:"course",
        QRTitle:"",
      }
    },
    methods: {
      closeQR(){
        this.isShowQR=false;
      },
      getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 60 - 15 - 46 - 40 - 15 //header + crumb + search + padding + updownShelf + pages + marinbottom
      },
      _addBtn() {
        this.popShow = true
        this.$router.push({name: 'NewCourse'})
        saveLocalStorage(false, 'isModify')
        saveLocalStorage('', 'bianjiData')

      },
      __currentPage(payload) {
        this.page.currentPage = payload
        this.getCourse(this.page.currentPage)
      },
      __pageSize(payload) {
        this.page.pageSize = payload
        this.getCourse(this.page.currentPage)
      },
      upShelf(){
        this.isUpShelf = true
        this.$refs.listSelection.getList()
      },
      downShelf(){
        this.isUpShelf = false
        this.$refs.listSelection.getList()
      },
      submitSelection(val){
        this.studyList = val
          var ifShelf = ""
          var idList = ""
          if(val.length == 0){
            message("请至少选择一门课程")
          }else{
              val.forEach( ele => {
                let id = ele.id.toString()
                idList += "," + id
                if (idList.substr(0,1)==','){
                    idList=idList.substr(1);
                }
                // onShelfId = idList.split(",")
                ifShelf += ele.onShelf
              })
              if(this.isUpShelf){
              this.$confirm("确定要将当前课程上架吗？", '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                 }).then(() => {

                  let params = {
                    type:1,
                    courseList:idList
                  }
                  http.post('/course/editMateria.json', params).then(res => {
                        if (res.data.code === _.ERR_OK) {
                            message("上架成功",true)
                            this.getCourse()
                            this.$refs.listSelection.clearList()
                        }else{
                            message(res.data.msg)

                        }
                    }).catch(err => {
                  })

                 })

              }else{
              this.$confirm("确定要将当前课程下架吗？", '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                 }).then(() => {
                    let params = {
                      type:2,
                      courseList:idList
                    }
                      http.post('/course/editMateria.json', params).then(res => {
                            if (res.data.code === _.ERR_OK) {
                                message("下架成功",true)
                                this.getCourse()
                                this.$refs.listSelection.clearList()
                            }else{
                               message(res.data.msg)

                            }
                        }).catch(err => {
                      })

              })
              }

          }


      },
      getCourse(cpage) {
        let page = 0
        if (cpage === '1') {
          page = 1
          this.page.currentPage = 1
        } else {
          page = cpage
          this.page.currentPage = cpage
        }
        let params = {
          onShelf:this.shelfStates,
          courseState: this.cStates,
          subject: this.theSubject,
          pageSize: this.page.pageSize,
          currentPage: page
        }
        http.post('/course/queryCourseList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {

          this.dataList = []

          for (let i = 0; i < res.data.model.length; i++) {
            res.data.model[i].teachType = changeteachType(res.data.model[i].teachType)
            res.data.model[i].courseTypeId = changecourseType(res.data.model[i].courseTypeId)
            res.data.model[i].courseState = courseStates(res.data.model[i].courseState)
            res.data.model[i].onShelf = onShelfState(res.data.model[i].onShelf)
        // res.data.model[i].onShelf
            this.dataList.push(res.data.model[i]);
            this.page.total = res.data.totalItem
          }

            for (let item of this.dataList) {
              if (item.onShelf === '1') {
                 // item.txtcolor == '1'
              } else {
                item.openFlag = '私人'
              }

              if(item.teachType ==='自主学习'){
                item.courseTimeStr = ''
              }

            }
          } else {
           message(res.data.msg, false)
          }
        }).catch(err => {
         // errMsg(err)
        })
      },
      _operation_(payload) {
        if (payload.operation === 'icon-chakan') {

          saveLocalStorage( this.dataList[payload.index].id,'Id')
          this.popShow = true
          this.$router.push({name: "LookCourse"})


        } else if (payload.operation === 'icon-bianji') {
            if(this.dataList[payload.index].onShelf == '已上架' || this.dataList[payload.index].courseState == '已结束'|| this.dataList[payload.index].courseState == '进行中'){
              return false
            }else{
             let params = {
               id: payload.id
             }
             http.post('/course/getCourseDetail.json', params).then(res => {
               if (res.data.code === _.ERR_OK) {
                 this.popShow = true;
                 this.$router.push({name: 'NewCourse',params: res.data.model})

                //  saveLocalStorage(res.data.model, 'bianjiData')
                //  console.log(res.data.model,'============')
                 saveLocalStorage(true, 'isModify')
               } else {
               //  message(res.data.msg, false)
               }
             })
            }
        } else if (payload.operation === 'icon-jinru') {
             http.post('/getUserInfo.json').then(res => {
              if(res.data.code===_.ERR_OK){
              this.conTime = new Date(res.data.model.doctorSign.replace("-","/")).getTime()
               if((this.dataList[payload.index].courseState == '已结束'|| this.dataList[payload.index].courseState == '进行中' ||this.dataList[payload.index].courseState == '未开始'|| this.dataList[payload.index].courseState === ' ' ) && this.dataList[payload.index].onShelf === '已上架'){
                        let CourseId= this.dataList[payload.index].id
                        let curTime=nomalTime(this.dataList[payload.index].courseTime);
                        let courTIme=curTime.replace("-","/");
                        let d2 = new Date(); //取今天的日期
                        let d1=new Date(Date.parse(courTIme)) //课程的时间
                        let hosSecond=d1.getTime()-this.conTime  //时间差的毫秒数
                        let courseTimeStr=new Date(courTIme).getTime()
                        if(hosSecond >'1800000'){
                           message('最多只能提前半小时进入课程', false)
                        }else if(hosSecond < '1800000'&&this.dataList[payload.index].courseState == '未开始'){
                          this.$confirm('还未到课程开始时间，是否要提前开始课程', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText:'取消'
                          }).then(() =>{
                         http.post('/course/comingCourse.json', {Id:this.dataList[payload.index].id}).then(res => {
                            if (res.data.code == "SUCCESS") {
                             window.open(`${window.BROWSER_URL}teachRoom?videoCenter&type=tenchManage&lessonId=${CourseId}`,'_blank')
                           }
                          })

                          }).catch(()=>{

                          })
                        }else{

                            window.open(`${window.BROWSER_URL}teachRoom?videoCenter&type=tenchManage&lessonId=${CourseId}`,'_blank')
                        }

            // window.open(`${window.BROWSER_URL}teachRoom?videoCenter&type=tenchManage&lessonId=${CourseId}`,'_blank')
            }else{
            return false
             }
            }
           })
         }else if (payload.operation === 'icon-shanchu') {
          if(this.dataList[payload.index].onShelf == '未上架' ){
             this.$confirm('是否确定要删除?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
             }).then(() => {
               let params = {
                 id: payload.id
               }
               http.post('/course/delCourse.json', params).then(res => {
                 if (res.data.code === _.ERR_OK) {
                   this.getCourse()
                 } else {
                  message(res.data.msg, false)
                 }
               })

             })
           }else{
            return false
           }

        } else if (payload.operation === 'icon-EQcode2'){

            this.QRId = payload.id+"";
            this.QRTitle= payload.subject;
            this.isShowQR = true;
        }

      },
      // cellClass({row, rowIndex, columnIndex}){
      //   if(row.courseState === '进行中' ){
      //     return 'color-red'
      //   }
      // },
      closePop(val) {
        this.pops = val;
      },
      _routerEach() {
        router.beforeEach((to, from, next) => {
          if (from.name === 'TeachManage') {
            this.popShow = true
          } else {
            this.popShow = false
          }
          next();
        })
      },
      cellClassName({row, rowIndex,column,columnIndex}) {
        if (row.courseState === '进行中' && column.label === '课程状态') {
          return 'color-red';
        } else if (row.courseState === '未开始' && column.label === '课程状态') {
          return 'color-green';
        }
      }
    },
    mounted() { //初始化完成加载时间
      setTimeout(() => {
        this._routerEach()
        if (this.$route.path === '/Homepage/TeachManage') {
          this.popShow = false
        } else {
          this.popShow = true
        }
      }, 20)
      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.getH()
        }, 50)
      })

      // setTimeout(() => { this.cellClassName() }, 1000)
      // setTimeout(() => {
      //   for (let item of this.dataList){
      //     console.log(item.courseState)
      //       if(item.courseState === '进行中'){
      //         this.cellName = 'color-red'
      //       }else if(item.courseState === '未开始'){
      //         this.cellName = 'color-green'
      //       }
      //   }
      // }, 1000)


    },
    watch: {
      popShow(c, o) {
        if (c === false) {
        this.getCourse(this.page.currentPage)
        }
      }
    },
    created() {
      this.getH()
      // this.autoheight = document.documentElement.clientHeight - 342px
      this.getCourse('1')
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .rightContent
    height: calc(100vh - 50px);
  .hospital-select
    width: 98%
    min-width: 980px
    margin: 0 auto
    background: $color-background-d
    padding: 1%
    .s-btn
      display: inline-block
      width: 120px
      height: 28px
      line-height: 28px
      background: $button-base-color
      color: $button-text-color
      text-align: center
      border-radius: 4px
    .open-meeting
      float: right
    .search-box
      float: left
      .reset
        margin-right: 20px
        &:hover
          text-decoration: underline
      .search-btn
        background: $color-background-hover

  .check-type
  .doc-type
  .district-type
    height: 32px
    line-height: 32px
    width: 100%
    color: #000
    em
      font-style: normal
      width: 66px
      height: 32px
      margin-right: 6px
      color: $color-text
      float: left
    > li
      //padding: 0 20px 0 0
      float: left
      label
        cursor: pointer;
        padding: 0 6px
      span
        color:#9d9ea3

  .district-type
    > li
      el-input
      input[type=checkbox]
        display: inline-block
  .universal
    position: relative
    width: 98%
    min-width: 980px
    margin: auto

  .record
    overflow: hidden

  .record-left
    float: left
    width: 39%

  .record-right
    float: right
    width: 60%

  .shoucang
    display: block
    width: 160px
    height: 30px
    line-height: 30px
    text-align: center
    background: $color-background-hover
    color: $color-background-d
    border-radius: 3px
    margin: 20px auto 0
.addBtn
    width: 120px
    height: 27px
    float: right
    margin-top -3px
    position: relative
    top: 4px
    line-height: 27px
    text-align: center
    cursor: pointer
    background: #f3b200
    color: $color-index-text
    border-radius: 3px

.batch-process
    margin-top: 15px
    height: 46px
    background: $color-background-d
  .process-text
    float: left
    line-height: 46px
    margin-left:20px
  .process-ul
    float: left
    margin-top: 9px
    li
      position: relative
      float: left
      width:70px
      height:28px
      line-height:28px
      color: #000
      border-radius: 2px
      margin-right:10px
      cursor: pointer
    .el-button
      color: #000
      text-indent:  15px
      padding 0
      height: 30px;
      line-height: 30px;
      width: 70px;
      border 1px solid $border-color
    i
      position: absolute
      left: 6px
      top: 14px
</style>



// WEBPACK FOOTER //
// teachManage.vue?50a649c2